import { shield } from "./common.js";
import { formatLocale } from "d3-format";

function getFormatFunction(interp) {
	var decimal = interp.decimal_mark;
	var thousands = interp.thousand_separator;
	var locale = formatLocale({
		decimal: decimal,
		thousands: thousands,
		grouping: [3],
		currency: ["", ""],
	});
	var format, specifier;

	return function (value, spec) {
		if (value === null) return "";
		if (!spec) spec = ",.2f";
		if (spec !== specifier) {
			specifier = spec;
			format = locale.format(specifier);
		}
		return format(value);
	};
}

// https://stackoverflow.com/a/16148273
var comma_point = {
	test: shield(function (str) {
		return /^(\+|-)?\d{1,3}(,\d{3})*(\.\d+)?((e|E)(\+|-)?\d+)?$/.test(
			str.trim(),
		);
	}),
	parse: shield(function (str) {
		return parseFloat(str.replace(/,/g, ""));
	}),
	description: "Comma thousand separator, point decimal mark",
	thousand_separator: ",",
	decimal_mark: ".",
	id: "number$comma_point",
	example: "12,235.56",
};

var space_point = {
	test: shield(function (str) {
		return /^(\+|-)?\d{1,3}(\s\d{3})*(\.\d+)?((e|E)(\+|-)?\d+)?$/.test(
			str.trim(),
		);
	}),
	parse: shield(function (str) {
		return parseFloat(str.replace(/\s/g, ""));
	}),
	description: "Space thousand separator, point decimal mark",
	thousand_separator: " ",
	decimal_mark: ".",
	id: "number$space_point",
	example: "12 235.56",
};

var none_point = {
	test: shield(function (str) {
		return /^(\+|-)?\d+(\.\d+)?((e|E)(\+|-)?\d+)?$/.test(str.trim());
	}),
	parse: shield(function (str) {
		return parseFloat(str);
	}),
	description: "No thousand separator, point decimal mark",
	thousand_separator: "",
	decimal_mark: ".",
	id: "number$none_point",
	example: "12235.56",
};

var point_comma = {
	test: shield(function (str) {
		return /^(\+|-)?\d{1,3}(\.\d{3})*(,\d+)?((e|E)(\+|-)?\d+)?$/.test(
			str.trim(),
		);
	}),
	parse: shield(function (str) {
		return parseFloat(str.replace(/\./g, "").replace(/,/, "."));
	}),
	description: "Point thousand separator, comma decimal mark",
	thousand_separator: ".",
	decimal_mark: ",",
	id: "number$point_comma",
	example: "12.235,56",
};

var space_comma = {
	test: shield(function (str) {
		return /^(\+|-)?\d{1,3}(\s\d{3})*(,\d+)?((e|E)(\+|-)?\d+)?$/.test(
			str.trim(),
		);
	}),
	parse: shield(function (str) {
		return parseFloat(str.replace(/\s/g, "").replace(/,/, "."));
	}),
	description: "Space thousand separator, comma decimal mark",
	thousand_separator: " ",
	decimal_mark: ",",
	id: "number$space_comma",
	example: "12 235,56",
};

var none_comma = {
	test: shield(function (str) {
		return /^(\+|-)?\d+(,\d+)?((e|E)(\+|-)?\d+)?$/.test(str.trim());
	}),
	parse: shield(function (str) {
		return parseFloat(str.replace(/,/, "."));
	}),
	description: "No thousand separator, comma decimal mark",
	thousand_separator: "",
	decimal_mark: ",",
	id: "number$none_comma",
	example: "12235,56",
};

var number_interpretations = Object.freeze([
	comma_point,
	space_point,
	point_comma,
	space_comma,
	none_point,
	none_comma,
]);

number_interpretations.forEach(function (interp) {
	interp.type = "number";
	interp.format = getFormatFunction(interp);
	Object.freeze(interp);
});

export { number_interpretations };
